import Alpine from 'alpinejs'
import { debounce } from './utils';

Alpine.store('global', {
    observer: null,
    observerOptions: {},
    announcementBannerInView: false,
    headerHeight: 0,

    init() {
        const announcementBanner = document.querySelector('#announcement-banner')
        const header = document.querySelector('#header')

        if (announcementBanner) {
            this.observerOptions = {
                root: null,
                rootMargin: '0px',
                threshold: [...Array(101).keys()].map(x => x / 100),
            };

            this.observer = new IntersectionObserver(this.handleAnnouncementBannerIntersect, this.observerOptions)
            this.observer.observe(announcementBanner)
        } else {
            this.headerHeight = header.offsetHeight
            document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`)
        }

        window.addEventListener('resize', debounce(() => this.handleResize(), 250))
    },
    handleResize() {
        const announcementBanner = document.querySelector('#announcement-banner')
        
        if (announcementBanner) {
            this.observer.unobserve(announcementBanner)
            this.observer.observe(announcementBanner)
        } else {
            const header = document.querySelector('#header')
            this.headerHeight = header.offsetHeight
            document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`)
        }
    },
    handleAnnouncementBannerIntersect(entries) {
        const announcementBanner = document.querySelector('#announcement-banner')
        const header = document.querySelector('#header')

        entries.forEach(entry => {
            this.announcementBannerInView = entry.isIntersecting

            if (entry.isIntersecting) {
                this.headerHeight = header.offsetHeight + (announcementBanner.offsetHeight * entry.intersectionRatio)
            } else {
                this.headerHeight = header.offsetHeight
            }

            document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`)
        })
    }
})

Alpine.store('productLightboxActive', false)

Alpine.store('nav', {
    navOpen: false,
    activeLinkIndex: null,

    toggleNav() {
        this.navOpen = !this.navOpen
    },
    closeNav() {
        this.navOpen = false
    },
    openMenu(index) {
        if (this.activeLinkIndex === null) {
            this.activeLinkIndex = index
        } else if (this.activeLinkIndex !== index) {
            this.activeLinkIndex = null
    
            setTimeout(() => {
                this.activeLinkIndex = index
            }, 150)
        }
    },
    closeMenu() {
        this.activeLinkIndex = null
    }
})

Alpine.store('cart', {
    open: false,
    count: 0,
    items: [],
    subTotal: 0,
    total: 0,

    init() {
        this.fetchCart()
    },

    toggle(state) {
        const newState = state ? state : !this.open
        this.open = newState
    },
    close() {
        this.open = false
    },
    setCount(value) {
        this.count = value
    },
    fetchCart() {
        fetch('/cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(data => {
            this.setItemsUpdateCart(data)
        })
        .catch((error) => {
            console.error('Fetching cart error:', error)
        })
    },
    removeItem(id) {
        const formData = {
            updates: {}
        }

        formData.updates[id] = 0

        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => this.setItemsUpdateCart(data))
        .catch((error) => {
            console.error('Remove from cart error:', error)
        })
    },
    setItemsUpdateCart(cart) {
        try {
            this.items = cart.items
            this.subTotal = cart.items_subtotal_price
            this.total = cart.total_price
            this.count = cart.item_count
        } catch(error) {
            console.error('Set items and update count error:', error)
        }
    },
    setQuantity(id, quantity) {
        if (this.quantityLoading || quantity === 0) return

        this.quantityLoading = true

        const formData = {
            id: id.toString(),
            quantity: quantity
        }

        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
            this.setItemsUpdateCart(data)
            this.quantityLoading = false
        })
        .catch((error) => {
            this.quantityLoading = false
            console.error('Set quantity error:', error)
        })
    },
    addToCart(quantity = 1, productId) {
        const formData = {
            items: [{
                id: productId,
                quantity: quantity
            }]
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
            this.fetchCart()
            this.toggle()
        })
        .catch((error) => {
            console.error('Add to cart error:', error)
        })
    }
})

Alpine.store('search', {
    isOpen: false,
    term: '',
 
    toggle() {
        this.isOpen = !this.isOpen
    },
    open() {
        this.isOpen = true
    },
    close() {
        this.isOpen = false
        this.term = ''
    }
})

Alpine.store('recoverPassword', {
    open: false,

    init() {
        const pathname = window.location.pathname 
        const hash = window.location.hash

        if (pathname === '/account/login' && hash === '#recover') {
            this.open = true
        }
    },
 
    toggle() {
        this.open = !this.open
    }
})
